module.exports = __webpack_public_path__ + "static/media/grabaseat5_preview.fbc7512a.jpg";